module.exports = __webpack_public_path__ + "img/btn_order_part_close02.1af17a0a.svg";